import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { API_URLS } from '../config/api';
import { t } from '../i18n';

const ConfirmEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage(t('Токен подтверждения отсутствует.'));
      return;
    }

    fetch(`${API_URLS.CONFIRM_EMAIL}?token=${encodeURIComponent(token)}`)
      .then(async (res) => {
        const data = await res.json();
        if (res.ok) {
          setStatus('success');
          // The server's own message is Russian; a reward is reported as a number so it can be
          // worded in the reader's language here.
          setMessage(data.stars_added > 0
            ? t('Вам начислено {0} звёзд за подтверждение email.', data.stars_added)
            : data.message || t('Email успешно подтверждён!'));
        } else {
          setStatus('error');
          setMessage(data.detail || t('Не удалось подтвердить email.'));
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage(t('Ошибка соединения. Попробуйте позже.'));
      });
  }, [searchParams]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {status === 'loading' && (
          <>
            <div style={styles.spinner} />
            <p style={styles.text}>{t('Подтверждаем ваш email…')}</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={styles.icon}>✅</div>
            <h2 style={styles.title}>{t('Email подтверждён!')}</h2>
            <p style={styles.text}>{message}</p>
            <Link to="/" style={styles.btn}>{t('Перейти на главную')}</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={styles.icon}>❌</div>
            <h2 style={styles.title}>{t('Ошибка')}</h2>
            <p style={styles.text}>{message}</p>
            <Link to="/" style={styles.btn}>{t('На главную')}</Link>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0a0a0f',
    fontFamily: "'Alegreya Sans', sans-serif",
    padding: '2rem',
  },
  card: {
    background: '#16161f',
    border: '1px solid #2a2a3a',
    borderRadius: '16px',
    padding: '2.5rem',
    maxWidth: '420px',
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },
  icon: { fontSize: '3rem' },
  title: { color: '#e8e8f0', margin: 0, fontSize: '1.5rem' },
  text: { color: '#9090a8', margin: 0, fontSize: '1rem', lineHeight: 1.6 },
  btn: {
    display: 'inline-block',
    marginTop: '0.5rem',
    padding: '0.75rem 2rem',
    background: '#7c3aed',
    color: '#fff',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '1rem',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #2a2a3a',
    borderTop: '4px solid #7c3aed',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
};

export default ConfirmEmailPage;
